import { CircleMarker } from "react-leaflet";
import "./pulsingicon.css";

export const PulsingIcon = ({ center }) => {    
    return (<CircleMarker className="pulsing-icon" center={center}/>);
}